import { MLSListing } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import { MLSDataSheetParams } from '../MLSDataSheet/types.ts';
import { ReferenceViewID } from '../index.ts';
import { MLSHeaderType } from '../types.ts';
import { MLSListingIDText } from './MLSListingIDText.tsx';

export const MLSListingID = ({
  listingData,
  isPopout,
  referenceViewID,
  headerType,
  mlsDataSheetParams,
}: {
  listingData: MLSListing;
  isPopout: boolean;
  referenceViewID: ReferenceViewID;
  headerType: MLSHeaderType;
  mlsDataSheetParams: MLSDataSheetParams;
}) => {
  const { openPopup, orderID } = mlsDataSheetParams;

  return headerType === 'images' ? (
    <Flex
      onPress={() => {
        if (!isPopout) {
          openPopup(
            `/reference-data/${orderID}/mls-listing/${referenceViewID}`,
            '_blank',
            'rel=noopener noreferrer',
          );
        }
      }}
      cursor="pointer"
    >
      <MLSListingIDText listingData={listingData} isPopout={isPopout} headerType={headerType} />
    </Flex>
  ) : (
    <MLSListingIDText listingData={listingData} isPopout={isPopout} headerType={headerType} />
  );
};
